module.exports = __webpack_public_path__ + "media/images/countryrect/mo-42d06492143d201c5841f65e531a3839.svg";